module.exports = __webpack_public_path__ + "img/LoaderDiya.604d1f96.gif";